export const createArrayOfPersonIds = (ids) =>
  ids.map((id) => (id instanceof Object ? id : { personId: id }));
